<p-fieldset legend="Ata de abertura e julgamento das propostas">
  <div class="row">
    <label class="required col-3 col-form-label">
      Há no procedimento ata de abertura e julgamento das propostas?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoPropostas"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label"
      *ngIf="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoPropostas === 'S'">
      Data da ata de abertura
    </label>
    <p-calendar (onFocus)="onFocusDate()"*ngIf="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoPropostas === 'S'"
      [(ngModel)]="entidade.JulgamentoComInversao.ExisteAtaAberturaJulgamentoPropostas.Data"
      [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
      dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
  <div class="row" *ngIf="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoPropostas === 'S'">
    <label class="required col-3 col-form-label">
      Há no procedimento ata de julgamento das propostas?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.JulgamentoComInversao.NaoExisteAtaJulgamentoPropostas"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label"
      *ngIf="entidade.JulgamentoComInversao.NaoExisteAtaJulgamentoPropostas === 'S'">
      Data da ata de julgamento
    </label>
    <p-calendar (onFocus)="onFocusDate()"*ngIf="entidade.JulgamentoComInversao.NaoExisteAtaJulgamentoPropostas === 'S'"
      [(ngModel)]="entidade.JulgamentoComInversao.ExisteAtaJulgamentoPropostas.Data"
      [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
      dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
</p-fieldset>
<p-fieldset legend="Ata de abertura e julgamento da habilitação">
  <div class="row">
    <label class="required col-3 col-form-label">
      Há no procedimento ata de abertura e julgamento dos documentos de habilitação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoDocumentosHabilitacao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
    <label class="required col-3 col-form-label"
      *ngIf="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoDocumentosHabilitacao === 'S'">
      Data da ata de abertura e Julgamento
    </label>
    <p-calendar (onFocus)="onFocusDate()"*ngIf="entidade.JulgamentoComInversao.NaoExisteAtaAberturaJulgamentoDocumentosHabilitacao === 'S'"
      [(ngModel)]="entidade.JulgamentoComInversao.ExisteAtaAberturaJulgamentoDocumentosHabilitacao.Data"
      [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
      dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
</p-fieldset>
<p-fieldset legend="Quadro comparativo de preços das propostas">
  <div class="row">
    <label class="required col-3 col-form-label">
      Há no procedimento ata de abertura e julgamento dos documentos de habilitação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
      [(ngModel)]="entidade.JulgamentoComInversao.QuadroComparativoAberturaProposta"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>
<lib-licitacao-audesp-recurso [entidade]="entidade"></lib-licitacao-audesp-recurso>
<p-fieldset legend="Sessão Pública">
  <div class="row">
    <label class="required col-3 col-form-label">
      Houve ata de sessão pública?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.SessaoPublica"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>